import {autoInit, loader, logger, pubSub} from '@changke/staticnext-lib';
import {i18n} from '../services/i18n';

interface ModuleInitData {
  moduleName: string;
}

class App {
  start(assetPath = {css: '', js: '', modules: ''}) {
    pubSub.subscribe('mod:init', data => {
      logger.log('app', `Module "${(data as ModuleInitData).moduleName}" initialized.`);
    });

    pubSub.subscribe('mod:dynInit', modRoot => {
      autoInit(modRoot as Element, undefined, loader, assetPath);
    });

    // Init language data
    if (window.ui?.pageInfo) {
      const lang = window.ui.pageInfo.lang || 'zh-CN';
      const i18nData = window.ui.i18n;
      if (i18nData?.locale === lang) {
        i18n.init(i18nData.text);
      }
    }

    // Auto initialize modules on page
    autoInit(undefined, undefined, loader, assetPath);
  }
}

const app = new App();
export default app;
